import { render, staticRenderFns } from "./news_top.vue?vue&type=template&id=03fe20d2&scoped=true&lang=pug"
import script from "./news_top.vue?vue&type=script&lang=js"
export * from "./news_top.vue?vue&type=script&lang=js"
import style0 from "./news_top.vue?vue&type=style&index=0&id=03fe20d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fe20d2",
  null
  
)

export default component.exports